export default __webpack_public_path__ + "static/media/cryptex.418c82fe.gif";